import Script from 'next/script'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'
import {useTrustArcConsent} from '@/services/trustarc'

export type OutgrowWidgetContentItem = IContentItem<{
	outgrowId: Elements.TextElement
}>

export const OutgrowWidgetBlock: Block<OutgrowWidgetContentItem> = ({
	block,
}) => {
	const outgrowId = block.elements.outgrowId || ''
	const cookieConsent = useTrustArcConsent()

	if (!outgrowId) {
		return null
	}

	// Only load Outgrow script when user has given marketing/advertising consent
	// Outgrow has integrated analytics and should not load when marketing cookies are declined
	const hasConsent =
		cookieConsent === 'ALL_COOKIES' || cookieConsent === 'ADVERTISE_COOKIES'

	return (
		<div data-kontent-element-codename="outgrow_id">
			<div
				className="op-interactive"
				data-title="Outgrow Interactive Content"
				data-url={`https://elanco588.outgrow.us/${outgrowId}`}
				data-width="100%"
				id={outgrowId}
			/>
			{hasConsent ? (
				<Script
					dangerouslySetInnerHTML={{
						__html: `
						var og_temp=document.createElement('script');
						og_temp.async=true;
						og_temp.defer=true;
						og_temp.src='//dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js';
						og_temp.onload=function(){
							var origHref = window.location.href;
							var cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
							try {
								window.history.replaceState(null, '', cleanUrl);
								initIframe('${outgrowId}');
							} finally {
								window.history.replaceState(null, '', origHref);
							}
						};
						document.querySelector('head').appendChild(og_temp);
					`,
					}}
					id={`outgrow-loader-${outgrowId}`}
					strategy="afterInteractive"
				/>
			) : null}
		</div>
	)
}
